"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserBase = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var WorldStatus_1 = require("./WorldStatus");
var PlatformMark_1 = require("./PlatformMark");
var UserStatus_1 = require("./UserStatus");
var TrustMark_1 = require("./TrustMark");
var util_1 = require("../util");
var cardTextStyle = { wordWrap: "break-word", overflowWrap: "break-word" };
exports.UserBase = React.memo(function (_a) {
    var user = _a.user, main = _a.main, besideName = _a.besideName, footer = _a.footer, meta = _a.meta, world = _a.world, worldLoading = _a.worldLoading, color = _a.color;
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Card, { color: color, children: [(0, jsx_runtime_1.jsx)(UserImage, { src: user.profilePicOverride || user.currentAvatarThumbnailImageUrl || user.currentAvatarImageUrl }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Card.Content, { children: [(0, jsx_runtime_1.jsx)(UserNames, { username: user.username, displayName: user.displayName, lastPlatform: user.last_platform }), besideName, meta && (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Meta, { children: meta }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Description, { style: cardTextStyle, children: main })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Card.Content, { extra: true, style: cardTextStyle, children: [(0, jsx_runtime_1.jsx)(UserStatus_1.UserStatus, { status: user.status, statusDescription: user.statusDescription }), (0, jsx_runtime_1.jsx)(TrustMark_1.TrustMark, { tags: user.tags })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Content, { extra: true, style: cardTextStyle, children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { columns: 2, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { floated: "left", children: world !== false && (0, jsx_runtime_1.jsx)(WorldStatus_1.WorldStatus, __assign({ world: world, loading: worldLoading }, user.locationInfo)) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { floated: "right", textAlign: "right", children: footer })] }) })] }));
});
var UserImage = React.memo(function (_a) {
    var src = _a.src;
    return (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { src: (0, util_1.imageUrl)(src) });
});
var UserNames = React.memo(function (_a) {
    var displayName = _a.displayName, username = _a.username, lastPlatform = _a.lastPlatform;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Card.Header, { style: cardTextStyle, children: [displayName, (0, jsx_runtime_1.jsx)(PlatformMark_1.PlatformMark, { platform: lastPlatform })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Meta, { style: cardTextStyle, children: username })] }));
});
